import { useEffect } from 'react';

import { useMeQuery } from 'src/hooks/queries/user';
import { SignupSource } from 'src/legacy/Components/auth/_constants';
import useUserStore from './useUserStore';

export const useUserStatusSync = () => {
	const { data: meData, error } = useMeQuery();
	const { userStatus, signupSource, setUser, token, id, email, name } =
		useUserStore();

	const rawApiStatus = error
		? undefined
		: (meData?.userStatus ?? (meData as any)?.status);
	const apiStatus = typeof rawApiStatus === 'string' ? rawApiStatus : undefined;
	const apiId = error ? undefined : meData?.id;

	useEffect(() => {
		const shouldSkipSync =
			userStatus === 'active' &&
			(apiStatus === 'otp_pending' ||
				(apiStatus === 'pending' && signupSource === SignupSource.LANDING_PAGE));

		const statusNeedsSync =
			apiStatus && apiStatus !== userStatus && !shouldSkipSync;
		const idNeedsSync = apiId && apiId !== id;

		const shouldSync = (statusNeedsSync || idNeedsSync) && token && email;

		if (shouldSync) {
			setUser({
				id: apiId || id,
				email,
				name,
				token,
				userStatus: apiStatus || userStatus,
				signupSource,
			});
		}
	}, [apiStatus, userStatus, signupSource, token, email, id, name, setUser, apiId]);
};
